<template>
  <div :class="activateCompetency ? 'active' : 'inactive'">
    <h1 class="mb-base text-left">The Sanctum of Knowledge {{activateCompetency}}</h1>
    <div class="flex -mx-3 relative">
      <div class="px-3 lg:w-1/3 sm:w-1/2 w-full">
        <vx-card class="overflow-hidden" noShadow>
          <template slot="no-body">
            <div :class="activateCompetency ? 'active-image-wrapper' : 'image-wrapper'">
              <img
                :src="libraryItemList[0].imageUrl"
                width="100%"
                height="auto"
              />
            </div>
          </template>
          <div class="training-item-body">
            <h5 class="mb-2 font-bold">{{ libraryItemList[0].title }}</h5>
            <p class="text-sm">{{ libraryItemList[0].description }}</p>
          </div>
          <template slot="footer">
            <div class="flex justify-end items-center">
              <p class="card-footer-text mr-1" style="color: #3089f0;">{{ $t('alex.startLibraryCourse') }}</p>
              <arrow-right-icon
                size="1x"
                style="color: #3089f0;"
                class="footer-icon"
              ></arrow-right-icon>
            </div>
          </template>
        </vx-card>
      </div>
      <div class="px-3 lg:w-1/3 sm:w-1/2 sm:block hidden">
        <vx-card class="overflow-hidden" noShadow>
          <template slot="no-body">
            <div :class="activateCompetency ? 'active-image-wrapper' : 'image-wrapper'">
              <img
                :src="libraryItemList[1].imageUrl"
                width="100%"
                height="auto"
              />
            </div>
          </template>
          <div class="training-item-body">
            <h5 class="mb-2 font-bold">{{ libraryItemList[1].title }}</h5>
            <p class="text-sm">{{ libraryItemList[1].description }}</p>
          </div>
          <template slot="footer">
            <div class="flex justify-end items-center">
              <p class="card-footer-text mr-1" style="color: #3089f0;">{{ $t('alex.startLibraryCourse') }}</p>
              <arrow-right-icon
                size="1x"
                style="color: #3089f0;"
                class="footer-icon"
              ></arrow-right-icon>
            </div>
          </template>
        </vx-card>
      </div>
      <div class="px-3 lg:w-1/3 lg:block hidden">
        <vx-card class="overflow-hidden" noShadow>
          <template slot="no-body">
            <div :class="activateCompetency ? 'active-image-wrapper' : 'image-wrapper'">
              <img
                :src="libraryItemList[2].imageUrl"
                width="100%"
                height="auto"
              />
            </div>
          </template>
          <div class="training-item-body">
            <h5 class="mb-2 font-bold">{{ libraryItemList[2].title }}</h5>
            <p class="text-sm">{{ libraryItemList[2].description }}</p>
          </div>
          <template slot="footer">
            <div class="flex justify-end items-center">
              <p class="card-footer-text mr-1" style="color: #3089f0;">{{ $t('alex.startLibraryCourse') }}</p>
              <arrow-right-icon
                size="1x"
                style="color: #3089f0;"
                class="footer-icon"
              ></arrow-right-icon>
            </div>
          </template>
        </vx-card>
      </div>
      <div class="view-more" v-if="activateCompetency " >
        <a  @click="activeMsp()" :href="`/${organizationSlug}/library`"> <img src="../../../../../assets/images/icons/gala/right-arrow-blue.svg" style="color: #3089f0;" /></a>
      </div>
      <div class="view-more" v-else-if="activateCompetency" >
        <a   @click="activeMsp()"  :href="`/${organizationSlug}/library`" > <img src="../../../../../assets/images/icons/gala/right-arrow-blue.svg" /></a>
      </div>
      <div class="view-more" v-else >
        <img src="../../../../../assets/images/icons/gala/right-arrow-grey.svg" />
      </div>
    </div>
  </div>
</template>
<script>
import { ArrowRightIcon } from "vue-feather-icons";

export default {
  components: {
    ArrowRightIcon,
  },
  data() {
    return {  userId:'',
      boardSlug:'',
      libraryItemList: [
        {
          itemId: "",
          imageUrl:
            "https://getboarded-backup-new.s3.us-east-2.amazonaws.com/static/Rectangle-1.svg",
          title: "10 Steps to Launching a Successful...",
          description:
            "Proactive workers are in high demand, and it’s easy to understand why. When it comes to creating positive change, these employees don’t need to be told to take initiative.",
        },
        {
          itemId: "",
          imageUrl:
            "https://getboarded-backup-new.s3.us-east-2.amazonaws.com/static/Rectangle-2.svg",
          title:
            "10+ Process Improvement Examples..",
          description:
            "To move people analytics forward, people experts need the skills to ask the right questions of the data and turn",
        },
        {
          itemId: "",
          imageUrl:
            "https://getboarded-backup-new.s3.us-east-2.amazonaws.com/static/Rectangle-3.svg",
          title: "12 Business Lessons You Can Learn from...",
          description:
            "Conquer anxiety, reduce stress, increase productivity and improve relationships. All by being attentive and cherishing the moment. This is mindfulness.",
        },

      ],
    };
  },
  computed: {
    organizationId() {
      return this.$store.state.organization.orgData._id;
    },
    autoLoginToken() {
      return  this.$store.state.boards.userBoardData.youlabToken;
    },
    userProgress() {
      return this.$store.state.boards.userBoardData.progress;
    },
    activateFeedback() {
      return this.autoLoginToken && this.userProgress >= 1;
    },
    activateCompetency() {
      return this.autoLoginToken && this.userProgress >= 2;
    },
    activatePreferences() {
      return this.autoLoginToken && this.userProgress >= 2;
    },
    organizationName() {
      return this.$store.state.organization.orgData.name;
    },
    organizationSlug() {
      return this.$store.state.organization.orgData.slug;
    }
  },
  methods:{
    activeMsp(){

    }
  },
  created() {
    let  url = this.$route.path.split('/');
    this.boardSlug = url[2];
    this.userId = url[3];
    const orgSlug =  url[1];
    if (orgSlug) {
      this.$store
        .dispatch("organization/fetchOrganizationBySlug", orgSlug)
        .then((res) => {
          console.log('res.data', res.data.data[0]);
          this.organizationSlug=res.data.data[0].slug
          this.organizationName=res.data.data[0].name
          if (!res.data.data[0].activeMarketplace) this.$router.push("/");
          else {
            this.$store.dispatch("journey/fetchUserSegments", {orgId: res.data.data[0]._id});

          }
        })
        .catch((err) => {
          throw err;
        });
    }
    // this.$store
    //   .dispatch("boards/fetchUserBoardData",this.userId )
    //   .then((res) => {
    //
    //     // this.$store.commit(
    //     //   "boards/SET_USER_BOARD_DATA",
    //     //   res.data
    //     // );
    //     // console.log('res.data',res.data);
    //
    //   })
    //   .catch((err) => {
    //     throw err;
    //   });
  }
};
</script>
<style scoped>
p {
  line-height: unset;
  font-size: unset;
}
section {
  padding: 8rem 0;
}
.active h1,
.active h5 {
  color: #231d4f;
}
.active p {
  color: #848199;
}
.active p.card-footer-text,
.active .footer-icon {
  color: #dc0032;
}
.inactive h1,
.inactive p,
.inactive h5,
.inactive .footer-icon {
  color: #ccc !important;
}
.inactive div.vx-card {
  border: 1px solid #eaf1fb;
}
.training-item-body {
  min-height: 140px;
  margin:0px;
}
.image-wrapper img {
  position: absolute;
}
.image-wrapper {
  position: relative;
  height: 300px;
  width: 100%;
  overflow: hidden;
  opacity: 0.2;
}
.active-image-wrapper{
  position: relative;
  height: 200px;
  width: 100%;
  overflow: hidden;
  opacity: 1;
}
.view-more {
  position: absolute;
  right: -25px;
  top: 275px;
  color: #231d4f;
}
</style>
